export default {
  title: "Invoice overview",
  noRecords: "No invoices found",
}
